<template>
    <div class="p-3">
        <div v-if="show" class="row mt-5">
            <div class="col-sm-4"></div>
            <div class="col-sm-4">
                <b-card
                    class="p-3"
                >
                    <b-card-text>
                        <b-form>
                            <b-form-input
                                v-model="form.username"
                                type="text"
                                placeholder="Username"
                                @keyup.enter="doLogin"
                            ></b-form-input>
                            <b-form-input
                                class="mt-3"
                                v-model="form.password"
                                type="password"
                                placeholder="Username"
                                @keyup.enter="doLogin"
                            ></b-form-input>

                            <div class="mt-3" style="text-align:right">
                                <b-button class="btn-sm" @click="doReset">Batal</b-button>
                                <b-button class="btn-sm" variant="primary" @click="doLogin">Masuk</b-button>
                            </div>
                        </b-form>
                    </b-card-text>
                </b-card>
            </div>
            <div class="col-sm-4"></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: {
                username: null,
                password: null
            },
            user: null,
            show: false
        }
    },
    created() {
        this.getAuth()
    },
    methods: {
        getAuth() {
            this.user = localStorage.getItem('user')

            if (this.user) {
                location.href = '/portal'
            } else {
                this.show = true
            }
        },
        doLogin() {
            this.$isLoading(true)
            let uri = '/api/login'
            this.axios.post(uri, this.form).then(response => {
                localStorage.setItem('user', JSON.stringify(response.data.user))
                localStorage.setItem('access_token', response.data.token)

                location.href = '/portal'
            }).catch(error => {
                this.$isLoading(false)
                let err_response = error.response
                if (err_response.status == 401) {
                    this.$swal.fire('Login gagal!', '', 'error')
                }
            })
        },
        doReset() {
            this.$router.push({ name: 'home' }).catch(()=>{})
        }
    }
}
</script>
